import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { connect } from "react-redux";
import SettingsSvg from "../../Images/Settings.svg";
import { createUser, editUser  } from "../../Redux/Actions/userActions";
import SideBar from "../Sidebar/SideBar";
import "./Settings.css";

import SettingTypesMgntCard from "./SettingTypesMgntCard"; 
import SettingUserMgntCard from "./SettingUserMgntCard"; 

function Settings({ editUser, createUser, userData, props }) {

  const { t } = useTranslation();
  const [admin] = useState(userData.role === 0);

  useEffect(() => {
    document.title = `SheetAble - ${t("PageSettings.pageTitle")}`;
  }, [t]);

  return (
    <Fragment>
      <SideBar />
      <div className="home_content settings">
        <div className="doc_header">
          <span className="doc_sheet">{t("PageSettings.pageTitle")}</span>
          <br />
          <span className="doc_composer ">
            Account Status: <b>{admin ? "Admin" : "Non Admin"}</b>
            {!admin && (
              <div className="no-settings">
                {" "}
				{t("PageSettings.statusMsg_no_admin")}	
              </div>
            )}
          </span>
        </div>

        {admin ? (
          <div className="admin-wrapper" style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
            <SettingUserMgntCard createUser={createUser} editUser={editUser} />
            <SettingTypesMgntCard typeOfSetting="songtype" textForHeader={t("PageSettings.typeOfSetting_songtype")} />
            <SettingTypesMgntCard typeOfSetting="artisttype" textForHeader={t("PageSettings.typeOfSetting_artisttype")} />
            <SettingTypesMgntCard typeOfSetting="gender" textForHeader={t("PageSettings.typeOfSetting_gender")} />
            <SettingTypesMgntCard typeOfSetting="classification" textForHeader={t("PageSettings.typeOfSetting_classification")} />
            <SettingTypesMgntCard typeOfSetting="instrument" textForHeader={t("PageSettings.typeOfSetting_instrument")} />
          </div>
        ) : (
          <div className="non-admin-wrapper">
            <img src={SettingsSvg} alt="" />
          </div>
        )}

      </div>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  userData: state.user.userData,
});

const mapActionsToProps = {
  createUser,
  editUser
};

export default connect(mapStateToProps, mapActionsToProps)(Settings);
